<template>
    <div class="products_listing">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing searcharea">
                <div class="filterbar">
                    <h6>SEARCH BY</h6>
                    <h4>{{searchterm}}</h4>
                </div>
                <div class="productsbar">
                    <div class="searcharea">
                        <div class="topsection">
                            <h1>Fabric</h1>
                        </div>
                        <div class="mainproducts">
                            <p v-if="fabricRows == true">No results found.</p>
                            <div class="productbox" v-for="(lp,lpk) in loadFabricProducts" :key="lpk">
                                <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="imgbox" :target="hrefTarget(lp.ITEMID,lp.DETAIL[0].INVENTCOLORID)">
                                    <b-img class="proimg" :src="lp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                    <b-img class="cw-overlay" v-if="lp.COLORWORKS == 1" src="/shop/images/cw-overlay.png"></b-img>
                                    <span v-if="lp.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                                    <span v-if="(lp.DETAIL[0].ABCCODEVALUE != 'A' && lp.DETAIL[0].ABCCODEVALUE != 'B' && lp.DETAIL[0].ABCCODEVALUE != 'C' && lp.DETAIL[0].ABCCODEVALUE != 'D' && lp.DETAIL[0].ABCCODEVALUE != 'E' && lp.DETAIL[0].ABCCODEVALUE != 'F' && lp.DETAIL[0].ABCCODEVALUE != 'X' && lp.DETAIL[0].ABCCODEVALUE != 'L') && lp.DETAIL[0].DISCOUNTPRICE > 0" class="saletag">Sale</span>
                                </a>
                                <div class="contentbox">
                                    <div class="smallimages" v-if="lp.DETAIL.length > 0">
                                        <a v-for="(sw,swind) in lp.DETAIL" :key="swind" :href="sw.LINK" v-if="sw.INVENTCOLORID != '99'" class="forborder" @mouseover="loadswatchdata(sw,lp.ITEMID,sw.INVENTCOLORID,$event)" :target="hrefTarget(lp.ITEMID,sw.INVENTCOLORID)">
                                            <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                        </a>
                                        <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="forborder" v-if="lp.TOTALSWATCH > 5"><div class="moreprod">+{{lp.TOTALSWATCH - 5}}</div></a>
                                    </div>
                                    <h4><a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" :target="hrefTarget(lp.ITEMID,lp.DETAIL[0].INVENTCOLORID)">{{lp.ITEMNAME}} / <span class="clname">{{lp.DETAIL[0].COLORNAME}}</span></a></h4>
                                    <!--<p v-if="lp.DETAIL[0].ABCCODEVALUE != 'A' && lp.DETAIL[0].ABCCODEVALUE != 'B' && lp.DETAIL[0].ABCCODEVALUE != 'C' && lp.DETAIL[0].ABCCODEVALUE != 'D' && lp.DETAIL[0].ABCCODEVALUE != 'E' && lp.DETAIL[0].ABCCODEVALUE != 'F'">{{lp.DETAIL[0].QTYONHAND}} left</p>-->
                                    <p v-if="lp.DETAIL[0].SHORTDESCRIPTION != ''">{{lp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                    <div v-if="lp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{lp.DETAIL[0].PRICE}}</p><span class="saleprice">${{lp.DETAIL[0].DISCOUNTPRICE}}</span></div>
                                    <p v-else-if="user.id > 0 && lp.DETAIL[0].DISCOUNTPRICE == 0">${{lp.DETAIL[0].PRICE}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="loadmorediv" v-if="fabricstate == true"><a @click="loadMoreFabric" href="javascript:;" class="btn btn-outline-primary btn-block rounded-0 loadmore">Load More</a></div>
                    </div>
                    <div class="searcharea">
                        <div class="topsection">
                            <h1>Trimming</h1>
                        </div>
                        <div class="mainproducts">
                            <p v-if="trimRows == true">No results found.</p>
                            <div class="productbox" v-for="(ltp,ltpk) in loadTrimProducts" :key="ltpk">
                                <a :href="'/shop/product/'+ltp.ITEMID+'/'+ltp.DETAIL[0].INVENTCOLORID " class="imgbox">
                                    <b-img class="proimg" :src="ltp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                    <span v-if="ltp.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                                    <span v-if="(ltp.DETAIL[0].ABCCODEVALUE != 'A' && ltp.DETAIL[0].ABCCODEVALUE != 'B' && ltp.DETAIL[0].ABCCODEVALUE != 'C' && ltp.DETAIL[0].ABCCODEVALUE != 'D' && ltp.DETAIL[0].ABCCODEVALUE != 'E' && ltp.DETAIL[0].ABCCODEVALUE != 'F' && ltp.DETAIL[0].ABCCODEVALUE != 'X' && ltp.DETAIL[0].ABCCODEVALUE != 'L') && ltp.DETAIL[0].DISCOUNTPRICE > 0" class="saletag">Sale</span>
                                </a>
                                <div class="contentbox">
                                    <div class="smallimages" v-if="ltp.DETAIL.length > 0">
                                        <a v-for="(sw,swind) in ltp.DETAIL" :key="swind" :href="'/shop/product/'+ltp.ITEMID+'/'+sw.INVENTCOLORID" class="forborder" @mouseover="loadswatchdata(sw,ltp.ITEMID,sw.INVENTCOLORID,$event)">
                                            <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                        </a>
                                        <a :href="'/shop/product/'+ltp.ITEMID+'/'+ltp.DETAIL[0].INVENTCOLORID " class="forborder" v-if="ltp.TOTALSWATCH > 5"><div class="moreprod">+{{ltp.TOTALSWATCH - 5}}</div></a>
                                    </div>
                                    <h4><a :href="'/shop/product/'+ltp.ITEMID+'/'+ltp.DETAIL[0].INVENTCOLORID ">{{ltp.ITEMNAME}} / <span class="clname">{{ltp.DETAIL[0].COLORNAME}}</span></a></h4>
                                    <!--<p v-if="ltp.DETAIL[0].ABCCODEVALUE != 'A' && ltp.DETAIL[0].ABCCODEVALUE != 'B' && ltp.DETAIL[0].ABCCODEVALUE != 'C' && ltp.DETAIL[0].ABCCODEVALUE != 'D' && ltp.DETAIL[0].ABCCODEVALUE != 'E' && ltp.DETAIL[0].ABCCODEVALUE != 'F'">{{ltp.DETAIL[0].QTYONHAND}} left</p>-->
                                    <p v-if="ltp.DETAIL[0].SHORTDESCRIPTION != ''">{{ltp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                    <div v-if="ltp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{ltp.DETAIL[0].PRICE}}</p><span class="saleprice">${{ltp.DETAIL[0].DISCOUNTPRICE}}</span></div>
                                    <p v-else-if="user.id > 0 && ltp.DETAIL[0].DISCOUNTPRICE == 0">${{ltp.DETAIL[0].PRICE}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="loadmorediv" v-if="trimstate == true"><a @click="loadMoreTrim" href="javascript:;" class="btn btn-outline-primary btn-block rounded-0 loadmore">Load More</a></div>
                    </div>
                    <div class="searcharea">
                        <div class="topsection">
                            <h1>Collections</h1>
                        </div>
                        <div class="mainproducts">
                            <p v-if="collectionRows == true">No results found.</p>
                            <div class="productbox" v-for="(lcp,lcpk) in loadCollectionProducts" :key="lcpk">
                                <div class="brandlogos"><b-img class="brandlogoimg" :src="'/shop/images/logos/'+lcp.RMCBRAND+'.png'"></b-img></div>
                                <a :href="lcp.PAGEURL" class="imgbox">
                                    <b-img class="proimg" :src="lcp.MEDIUM_IMAGE" fluid :alt="lcp.BOOKNAME"></b-img>
                                    <span v-if="(lcp.RMCLSCODE == 'LS25' || lcp.RMCLSCODE == 'LS50' || lcp.RMCLSCODE == 'AL')" class="saletag">Sale</span>
                                    <span v-if="lcp.ISNEW == true" class="newtag">New</span>
                                </a>
                                <div class="contentbox">
                                    <h4><a :href="lcp.PAGEURL">{{lcp.BOOKNAME}}</a></h4>
                                    <p v-if="lcp.DESCRIPTION">{{lcp.DESCRIPTION}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="loadmorediv" v-if="collectionstate == true"><a @click="loadMoreCollection" href="javascript:;" class="btn btn-outline-primary btn-block rounded-0 loadmore">Load More</a></div>
                    </div>
                    <div class="searcharea">
                        <div class="topsection">
                            <h1>Sample</h1>
                        </div>
                        <div class="mainproducts">
                            <p v-if="sampleRows == true">No results found.</p>
                            <div class="productbox" v-for="(lsp,lspk) in loadSampleProducts" :key="lspk">
                                <a :href="'/shop/sample/'+lsp.ITEMID" class="imgbox">
                                    <b-img class="proimg" :src="lsp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                </a>
                                <div class="contentbox">
                                    <div class="smallimages" v-if="lsp.DETAIL.length > 0">
                                        <a v-for="(sw,swind) in lsp.DETAIL" :key="swind" :href="'/shop/sample/'+lsp.ITEMID" class="forborder">
                                            <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                        </a>
                                        <a :href="'/shop/sample/'+lsp.ITEMID" class="forborder" v-if="lsp.TOTALSWATCH > 5"><div class="moreprod">+{{lsp.TOTALSWATCH - 5}}</div></a>
                                    </div>
                                    <h4><a :href="'/shop/sample/'+lsp.ITEMID">{{lsp.ITEMNAME}} / {{lsp.DETAIL[0].COLORNAME}}</a></h4>
                                    <p v-if="lsp.DETAIL[0].SHORTDESCRIPTION != ''">{{lsp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                    <div v-if="lsp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{lsp.DETAIL[0].PRICE}}</p><span class="saleprice">${{lsp.DETAIL[0].DISCOUNTPRICE}}</span></div>
                                    <p v-else-if="user.id > 0 && lsp.DETAIL[0].DISCOUNTPRICE == 0">${{lsp.DETAIL[0].PRICE}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="loadmorediv" v-if="samplestate == true"><a @click="loadMoreSample" href="javascript:;" class="btn btn-outline-primary btn-block rounded-0 loadmore">Load More</a></div>
                    </div>
                    <div class="searcharea">
                        <div class="topsection">
                            <h1>Showroom Items</h1>
                        </div>
                        <div class="mainproducts">
                            <p v-if="showroomRows == true">No results found.</p>
                            <div class="productbox" v-for="(lsp,lspk) in loadShowroomProducts" :key="lspk">
                                <a :href="'/shop/product/'+lsp.ITEMID+'/'+lsp.DETAIL[0].INVENTCOLORID " class="imgbox">
                                    <b-img class="proimg" :src="lsp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                    <span v-if="lsp.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                                    <span v-if="(lsp.DETAIL[0].ABCCODEVALUE != 'A' && lsp.DETAIL[0].ABCCODEVALUE != 'B' && lsp.DETAIL[0].ABCCODEVALUE != 'C' && lsp.DETAIL[0].ABCCODEVALUE != 'D' && lsp.DETAIL[0].ABCCODEVALUE != 'E' && lsp.DETAIL[0].ABCCODEVALUE != 'F' && lsp.DETAIL[0].ABCCODEVALUE != 'X' && lsp.DETAIL[0].ABCCODEVALUE != 'L') && lsp.DETAIL[0].DISCOUNTPRICE > 0" class="saletag">Sale</span>
                                </a>
                                <div class="contentbox">
                                    <div class="smallimages" v-if="lsp.DETAIL.length > 0">
                                        <a v-for="(sw,swind) in lsp.DETAIL" :key="swind" v-if="sw.INVENTCOLORID != '99'" :href="'/shop/product/'+lsp.ITEMID+'/'+sw.INVENTCOLORID" class="forborder" @mouseover="loadswatchdata(sw,lsp.ITEMID,sw.INVENTCOLORID,$event)">
                                            <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                        </a>
                                        <a :href="'/shop/product/'+lsp.ITEMID+'/'+lsp.DETAIL[0].INVENTCOLORID " class="forborder" v-if="lsp.TOTALSWATCH > 5"><div class="moreprod">+{{lsp.TOTALSWATCH - 5}}</div></a>
                                    </div>
                                    <h4><a :href="'/shop/product/'+lsp.ITEMID+'/'+lsp.DETAIL[0].INVENTCOLORID ">{{lsp.ITEMNAME}} / <span class="clname">{{lsp.DETAIL[0].COLORNAME}}</span></a></h4>
                                    <!--<p v-if="lsp.DETAIL[0].ABCCODEVALUE != 'A' && lsp.DETAIL[0].ABCCODEVALUE != 'B' && lsp.DETAIL[0].ABCCODEVALUE != 'C' && lsp.DETAIL[0].ABCCODEVALUE != 'D' && lsp.DETAIL[0].ABCCODEVALUE != 'E' && lsp.DETAIL[0].ABCCODEVALUE != 'F'">{{lsp.DETAIL[0].QTYONHAND}} left</p>-->
                                    <p v-if="lsp.DETAIL[0].SHORTDESCRIPTION != ''">{{lsp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                    <div v-if="lsp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{lsp.DETAIL[0].PRICE}}</p><span class="saleprice">${{lsp.DETAIL[0].DISCOUNTPRICE}}</span></div>
                                    <p v-else-if="user.id > 0 && lsp.DETAIL[0].DISCOUNTPRICE == 0">${{lsp.DETAIL[0].PRICE}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="loadmorediv" v-if="showroomstate == true"><a @click="loadMoreShowroom" href="javascript:;" class="btn btn-outline-primary btn-block rounded-0 loadmore">Load More</a></div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
    components: {
        CommonHead,
        CommonFoot,
        Loading
    },
    computed:{
        ...mapGetters(["user"])
    },
    mounted(){
        this.isLoading = true;
        this.loadMoreFabric();
        this.loadMoreTrim();
        this.loadMoreSample();
        this.loadMoreShowroom();
        this.loadMoreCollection();
    },
    data(){
        return{
            loadFabricProducts:[],
            loadTrimProducts:[],
            loadHardwareProducts:[],
            loadSampleProducts:[],
            loadShowroomProducts:[],
            loadCollectionProducts:[],
            fabricRows: false,
            trimRows: false,
            hardwareRows: false,
            sampleRows: false,
            showroomRows: false,
            collectionRows: false,
            isLoading: false,
            searchterm:null,
            breadcrumb: [
                {
                    text: 'Home',
                    href: '/'
                },
                {
                    text: 'Search results',
                    active: true
                }
            ],
            fabricpage: 0,
            trimpage: 0,
            samplepage: 0,
            showroompage: 0,
            collectionpage: 0,
            fabricstate: false,
            trimstate: false,
            samplestate: false,
            showroomstate: false,
            collectionstate: false,
        };
    },
    methods: {
        loadswatchdata(detail,itemid,inventcolorid,event){
            $(".productbox .imgbox").removeClass("active");
            $(event.target).parents(".productbox").children(".imgbox").addClass("active");
            let buildurl = $(event.target).attr("href");
            let hoverimg = detail.MEDIUM_IMAGE;
            let colornamehvr = detail.COLORNAME;
            $(event.target).parents(".productbox").children(".imgbox").attr("href",buildurl);
            $(event.target).parents(".productbox").children(".imgbox").children(".proimg").attr("src",hoverimg);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("href",buildurl);
            $(event.target).parents(".contentbox").children("h4").children("a").children(".clname").text(colornamehvr);
            let targetdata = this.hrefTarget(itemid,inventcolorid);
            $(event.target).parents(".productbox").children(".imgbox").attr("target",targetdata);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("target",targetdata);
        },
        loadMoreFabric(){
            this.isLoading = true;
            this.searchterm = this.$route.params.term;
            this.fabricpage = this.fabricpage + 1;
            let url = [];
            url["g"] = this.$route.params.term;
            url["page"] = this.fabricpage;
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadFabricSearchProducts",queryString).then(loadFabricProducts => {
                if(this.fabricpage > 1){
                    let oldFabs = this.loadFabricProducts;
                    let newFabs = loadFabricProducts.data.Fabric;
                    let conFabs = oldFabs.concat(newFabs);
                    this.loadFabricProducts = conFabs;
                }else{
                    this.loadFabricProducts = loadFabricProducts.data.Fabric;
                }
                this.isLoading = false;
                if(this.loadFabricProducts.length == 0){
                    this.fabricRows = true;
                }else{
                    this.fabricRows = false;
                }
                if(loadFabricProducts.data.Fabric.length >= 20){
                    this.fabricstate = true;
                }else{
                    this.fabricstate = false;
                }
            });
        },
        loadMoreTrim(){
            this.isLoading = true;
            this.trimpage = this.trimpage + 1;
            let url = [];
            url["g"] = this.$route.params.term;
            url["page"] = this.trimpage;
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadTrimSearchProducts",queryString).then(loadTrimProducts => {
                if(this.trimpage > 1){
                    let oldTrim = this.loadTrimProducts;
                    let newTrim = loadTrimProducts.data.Trim;
                    let conTrim = oldTrim.concat(newTrim);
                    this.loadTrimProducts = conTrim;
                }else{
                    this.loadTrimProducts = loadTrimProducts.data.Fabric;
                }
                this.isLoading = false;
                if(this.loadTrimProducts.length == 0){
                    this.trimRows = true;
                }else{
                    this.trimRows = false;
                }
                if(loadTrimProducts.data.Trim.length >= 20){
                    this.trimstate = true;
                }else{
                    this.trimstate = false;
                }
            });
        },
        loadMoreSample(){
            this.isLoading = true;
            this.samplepage = this.samplepage + 1;
            let url = [];
            url["g"] = this.$route.params.term;
            url["page"] = this.samplepage;
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadSampleSearchProducts",queryString).then(loadSampleProducts => {
                if(this.samplepage > 1){
                    let oldSam = this.loadSampleProducts;
                    let newSam = loadSampleProducts.data.Sample;
                    let conSam = oldSam.concat(newSam);
                    this.loadSampleProducts = conSam;
                }else{
                    this.loadSampleProducts = loadSampleProducts.data.Fabric;
                }
                this.isLoading = false;
                if(this.loadSampleProducts.length == 0){
                    this.sampleRows = true;
                }else{
                    this.sampleRows = false;
                }
                if(loadSampleProducts.data.Sample.length >= 20){
                    this.samplestate = true;
                }else{
                    this.samplestate = false;
                }
            });
        },
        loadMoreShowroom(){
            this.isLoading = true;
            this.showroompage = this.showroompage + 1;
            let url = [];
            url["g"] = this.$route.params.term;
            url["page"] = this.showroompage;
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadShowroomSearchProducts",queryString).then(loadShowroomProducts => {
                if(this.showroompage > 1){
                    let oldSroom = this.loadShowroomProducts;
                    let newSroom = loadShowroomProducts.data.Showrooms;
                    let conSroom = oldSroom.concat(newSroom);
                    this.loadShowroomProducts = conSroom;
                }else{
                    this.loadShowroomProducts = loadShowroomProducts.data.Fabric;
                }
                this.isLoading = false;
                if(this.loadShowroomProducts.length == 0){
                    this.showroomRows = true;
                }else{
                    this.showroomRows = false;
                }
                if(loadShowroomProducts.data.Showrooms.length >= 20){
                    this.showroomstate = true;
                }else{
                    this.showroomstate = false;
                }
            });
        },
        loadMoreCollection(){
            this.isLoading = true;
            this.collectionpage = this.collectionpage + 1;
            let url = [];
            url["g"] = this.$route.params.term;
            url["page"] = this.collectionpage;
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadCollectionSearchProducts",queryString).then(loadCollectionProducts => {
                if(this.collectionpage > 1){
                    let oldcoll = this.loadCollectionProducts;
                    let newcoll = loadCollectionProducts.data.Collections;
                    let concoll = oldcoll.concat(newcoll);
                    this.loadCollectionProducts = concoll;
                }else{
                    this.loadCollectionProducts = loadCollectionProducts.data.Collections;
                }
                this.isLoading = false;
                if(this.loadCollectionProducts.length == 0){
                    this.collectionRows = true;
                }else{
                    this.collectionRows = false;
                }
                if(loadCollectionProducts.data.Collections.length >= 20){
                    this.collectionstate = true;
                }else{
                    this.collectionstate = false;
                }
            });
        },
        hrefTarget(itemid, inventcolorid){
            var itemid = itemid;
            var inventcolorid = inventcolorid;
            var isCustomizer = "";
            if(itemid == 'CW100' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW101' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW104' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW105' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW106' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW109' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW110' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW111' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW113' && inventcolorid == '99'){
                isCustomizer = "1";
            }
            if(isCustomizer == ""){
                return "_self";
            }else{
                return "_blank";
            }
        }
    }
};
</script>
<style>
.loadmorediv{
    display:block;
    margin:0 auto 30px auto;
    max-width:140px;
}
.loadmorediv .btn.btn-outline-primary{
    padding-right:20px;
    padding-left:20px;
}
</style>
